import { FC } from 'react';

const Resources: FC = () => {
  return (
    <div>
      <h1>Hello, this is the Resources page</h1>
    </div>
  );
};

export default Resources;
